document.addEventListener('DOMContentLoaded', () => {
	let swiperInstances = {}
	const swiperEls = document.querySelectorAll('.swiper-container-multi')

	if (!swiperEls) return

	swiperEls.forEach((swiperEl, index) => {
		swiperEl.classList.add('instance-' + index)
		const prevButtonEl = swiperEl.querySelector('.swiper-button-prev')
		const nextButtonEl = swiperEl.querySelector('.swiper-button-next')
		if (prevButtonEl) prevButtonEl.classList.add('btn-prev-' + index)
		if (nextButtonEl) nextButtonEl.classList.add('btn-next-' + index)

		swiperInstances[index] = new Swiper('.instance-' + index, {
			loop: true,
			slidesPerView: '1',
			//slidesPerGroup: '1',
			spaceBetween: 200,
			//centeredSlides: true,
			//shortSwipes: false,
			grabCursor: true,
			freeMode: true,
			freeModeFluid: true,
			on: {
				sliderMove: function () {
					// hide any jquery tooltips
					// console.log('pbgallery slidermove')
					// jQuery('.ui-tooltip').fadeOut()
				},
				click: function () {
					// hide any jquery tooltips
					// console.log('pbgallery sliderclick')
					//jQuery('.ui-tooltip').fadeOut()
				},
			},
			breakpoints: {
				1100: {
					slidesPerView: '2.01',
					spaceBetween: 200,
				},
				760: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				10: {
					slidesPerView: 1.5,
					autoplay: true,
					spaceBetween: 100,
				}
			},
			nextButton: '.btn-next-' + index,
			prevButton: '.btn-prev-' + index,
			/*
				pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet: function(index, className) {
				return '<span class='' + className + ''>' + (index + 1) + '</span>'
				}
				},
			*/
			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		})
	})
})
